// extracted by mini-css-extract-plugin
export default {"about":"about_about__j-LoL","aboutdetails":"about_aboutdetails__tF0-a","container":"about_container__ZDUFn","name":"about_name__mytpf"};